import http from '@/services/http';
import { insertAnalysesDataFilters } from '@/config';
import tableHelper from '@/services/tableHelper';

const analysesData = {
  samplesIndex(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      insertAnalysesDataFilters
    );
    return http.request({
      method: 'get',
      url: '/samples',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  samplesCount(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(
      filterStatus,
      insertAnalysesDataFilters
    );
    return http.request({
      method: 'get',
      url: '/samples/count',
      params: { where },
      ...config,
    });
  },
  // samplesAnalysesIndex(sampleId, multiple = false) {
  //   const param = multiple ? sampleId : [sampleId];
  //   return http.request({
  //     method: 'get',
  //     url: '/sampleanalysis',
  //     params: {
  //       sampleIds: param,
  //     },
  //   });
  // },
  samplesAnalysesNewIndex(labSampleIds) {
    return http.request({
      method: 'get',
      url: '/analysisinsamples',
      params: {
        labSampleIds,
      },
    });
  },
  copyOperationValues(data) {
    return http.request({
      method: 'post',
      url: '/laboratory-sample-analyses/copy-operation-values',
      data,
    });
  },
  copyOperationValue(labSampleAnalysisId, data) {
    return http.request({
      method: 'post',
      url: `/laboratory-sample-analyses/${labSampleAnalysisId}/copy-operation-values`,
      data,
    });
  },
  patchLocation(analysisId, data) {
    return http.request({
      method: 'patch',
      url: `/laboratory-sample-analyses/${analysisId}`,
      data,
    });
  },
  laboratorySampleAnalysesAction(analysisId, data) {
    return http.request({
      method: 'patch',
      url: `/laboratory-sample-analyses/${analysisId}/action`,
      data,
    });
  },
  addSymbolLot(data) {
    return http.request({
      method: 'post',
      url: '/laboratory-sample-analyses/symbol-lots',
      data,
    });
  },
  checkValueInsertion(labSampleAnalysisId, operationRegistryIds) {
    return http.request({
      method: 'get',
      url: `/laboratory-sample-analyses/${labSampleAnalysisId}/check-value-insertion`,
      params: {
        operationRegistryIds,
      },
    });
  },
  // Dates as yyyy-MM-dd; the server reads the file only from the `file` field.
  prepareImport({ file, dateStart, dateEnd }) {
    const data = new FormData();
    data.append('dateStart', dateStart);
    data.append('dateEnd', dateEnd);
    data.append('file', file);
    return http.request({
      method: 'post',
      url: '/analyses-data/value-imports/prepare',
      headers: { 'Content-Type': 'multipart/form-data' },
      data,
    });
  },
};

export default analysesData;
